import { CloseOutlined } from '@ant-design/icons'
import CreateEventDrawerContent from './CreateEventDrawerContent'
import JobSearchFilters from './JobSearchFilters'
import { useScheduleFilters } from '../ScheduleFiltersContext'
import { Dayjs } from 'dayjs'

type Props = {
  open: boolean
  onClose: () => void
  initialTab?: string
  selectedDate?: Dayjs
}

const CreateEventDrawer = ({ open, onClose, initialTab, selectedDate }: Props) => {
  const { createEventFilters: filters, setCreateEventFilters: setFilters } = useScheduleFilters()

  if (!open) {
    return null
  }

  return (
    <div
      style={{
        width: 400,
        flexShrink: 0,
        backgroundColor: 'white',
        borderLeft: '1px solid #f0f0f0',
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - var(--title-bar-height))',
        overflow: 'hidden',
        position: 'sticky',
        top: 'var(--title-bar-height)',
        alignSelf: 'flex-start',
        animation: 'slideIn 0.2s ease-out',
      }}
      id="create-event-drawer"
    >
      <style>
        {`
          @keyframes slideIn {
            from {
              transform: translateX(100%);
            }
            to {
              transform: translateX(0);
            }
          }
        `}
      </style>
      <div
        style={{
          padding: '24px',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Add to Schedule</span>
        <CloseOutlined onClick={onClose} style={{ fontSize: '18px', cursor: 'pointer' }} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'auto' }}>
        <div style={{ backgroundColor: '#f5f5f5', padding: '12px' }}>
          <JobSearchFilters filters={filters} setFilters={setFilters} />
        </div>

        <CreateEventDrawerContent filters={filters} onEventCreated={onClose} initialTab={initialTab} selectedDate={selectedDate} />
      </div>
    </div>
  )
}

export default CreateEventDrawer
